import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Info, Keyboard } from "lucide-react";

const shortcuts = [
	{ keys: ["Espacio"], label: "Mostrar respuesta" },
	{ keys: ["1 - 4"], label: "Calificar tarjeta" },
	{ keys: ["S"], label: "Suspender tarjeta" },
	{ keys: ["F"], label: "Finalizar sesión" },
];

function Keycap({ children }) {
	return (
		<Box
			component="span"
			sx={{
				alignItems: "center",
				backgroundColor: "#f8fafc",
				border: "1px solid #dbe3ef",
				borderRadius: "7px",
				boxShadow: "inset 0 -1px 0 rgba(15, 23, 42, 0.08)",
				color: "#64748b",
				display: "inline-flex",
				fontSize: 13,
				fontWeight: 800,
				height: 26,
				justifyContent: "center",
				lineHeight: 1,
				minWidth: 40,
				px: 1.25,
			}}
		>
			{children}
		</Box>
	);
}

export default function AtajosFlashcards() {
	return (
		<Paper
			variant="outlined"
			sx={{
				borderColor: "#dfe5ee",
				borderRadius: "12px",
				boxShadow: "0 10px 30px rgba(15, 23, 42, 0.04)",
				p: { xs: 2, md: 2.5 },
				width: "100%",
			}}
		>
			<Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ mb: 1.5 }}>
				<Stack direction="row" alignItems="center" spacing={1.5}>
					<Box component="span" sx={{ color: "#64748b", display: "inline-flex" }}>
						<Keyboard size={24} strokeWidth={2.1} />
					</Box>
					<Typography sx={{ color: "#0f172a", fontSize: 16, fontWeight: 800 }}>
						Atajos de teclado
					</Typography>
				</Stack>
				<Box component="span" sx={{ color: "#64748b", display: "inline-flex" }}>
					<Info size={20} strokeWidth={2} />
				</Box>
			</Stack>

			<Stack spacing={1}>
				{shortcuts.map((shortcut) => (
					<Stack
						key={shortcut.label}
						direction="row"
						alignItems="center"
						spacing={2}
						sx={{ minHeight: 26 }}
					>
						<Box sx={{ minWidth: 78 }}>
							{shortcut.keys.map((key) => (
								<Keycap key={key}>{key}</Keycap>
							))}
						</Box>
						<Typography sx={{ color: "#475569", fontSize: 14, fontWeight: 600 }}>
							{shortcut.label}
						</Typography>
					</Stack>
				))}
			</Stack>
		</Paper>
	);
}
